import { AddressSystemType, NetworkIdType } from '@sonarwatch/portfolio-core';
import { Currency } from './types';

export const API_URL = import.meta.env.VITE_API_URL;
export const BUNDLE_MAX_SIZE = 30;
export const TURNSTILE_TTL = 3600000;
export const walletTokensPlatformId = 'wallet-tokens';
export const nativeStakePlatformId = 'native-stake';
export const walletNftsPlatformId = 'wallet-nfts';
export const unknownImageUrl = new URL(
  '/src/assets/unknown.png',
  import.meta.url,
).toString();

export const noImageUrl = new URL(
  '/src/assets/no_image.jpg',
  import.meta.url,
).toString();

export const noImageLogoUrl = new URL(
  '/src/assets/no_image_icon.png',
  import.meta.url,
).toString();

export const addressesSeparator = '_';

export const addressSystemLogos: Record<AddressSystemType, string> = {
  solana: new URL(
    '/src/assets/addresssystems/solana_mono.png',
    import.meta.url,
  ).toString(),
  bitcoin: new URL(
    '/src/assets/addresssystems/bitcoin_mono.png',
    import.meta.url,
  ).toString(),
  evm: new URL(
    '/src/assets/addresssystems/evm_mono.png',
    import.meta.url,
  ).toString(),
  move: new URL(
    '/src/assets/addresssystems/move_mono.png',
    import.meta.url,
  ).toString(),
  sei: new URL(
    '/src/assets/addresssystems/sei_mono.png',
    import.meta.url,
  ).toString(),
};

export const networkLightLogos: Record<NetworkIdType, string> = {
  solana: new URL(
    '/src/assets/networks/solana_light_mono.png',
    import.meta.url,
  ).toString(),
  bitcoin: new URL(
    '/src/assets/networks/bitcoin_light_mono.png',
    import.meta.url,
  ).toString(),
  ethereum: new URL(
    '/src/assets/networks/ethereum_light_mono.png',
    import.meta.url,
  ).toString(),
  avalanche: new URL(
    '/src/assets/networks/avalanche_light_mono.png',
    import.meta.url,
  ).toString(),
  sei: new URL(
    '/src/assets/networks/sei_light_mono.png',
    import.meta.url,
  ).toString(),
  sui: new URL(
    '/src/assets/networks/sui_light_mono.png',
    import.meta.url,
  ).toString(),
  aptos: new URL(
    '/src/assets/networks/aptos_light_mono.png',
    import.meta.url,
  ).toString(),
  bnb: new URL(
    '/src/assets/networks/bnb_light_mono.png',
    import.meta.url,
  ).toString(),
  polygon: new URL(
    '/src/assets/networks/polygon_light_mono.png',
    import.meta.url,
  ).toString(),
};

export const networkDarkLogos: Record<NetworkIdType, string> = {
  solana: new URL(
    '/src/assets/networks/solana_dark_mono.png',
    import.meta.url,
  ).toString(),
  bitcoin: new URL(
    '/src/assets/networks/bitcoin_dark_mono.png',
    import.meta.url,
  ).toString(),
  ethereum: new URL(
    '/src/assets/networks/ethereum_dark_mono.png',
    import.meta.url,
  ).toString(),
  avalanche: new URL(
    '/src/assets/networks/avalanche_dark_mono.png',
    import.meta.url,
  ).toString(),
  sei: new URL(
    '/src/assets/networks/sei_dark_mono.png',
    import.meta.url,
  ).toString(),
  sui: new URL(
    '/src/assets/networks/sui_dark_mono.png',
    import.meta.url,
  ).toString(),
  aptos: new URL(
    '/src/assets/networks/aptos_dark_mono.png',
    import.meta.url,
  ).toString(),
  bnb: new URL(
    '/src/assets/networks/bnb_dark_mono.png',
    import.meta.url,
  ).toString(),
  polygon: new URL(
    '/src/assets/networks/polygon_dark_mono.png',
    import.meta.url,
  ).toString(),
};

export const demoAddresses = ['DemoSX9F2zXfQLtBr56Yr5he15P7viZWsYJpSDAX3tKG'];
export const demoAddressesString = demoAddresses.join(addressesSeparator);

export const validatorAccount = 'sw222BfVDABppvydacSCj3JVaPSC83RoRtyvLmr6pNx';

export const currencies: Currency[] = [
  {
    name: 'USD',
    coinGeckoId: 'usd',
    symbol: '$',
    type: 'fiat',
  },
  {
    name: 'EUR',
    coinGeckoId: 'eur',
    symbol: '€',
    type: 'fiat',
    symbolPosition: 'after',
  },
  {
    name: 'GBP',
    coinGeckoId: 'gbp',
    symbol: '£',
    type: 'fiat',
  },
  {
    name: 'JPY',
    coinGeckoId: 'japanese-yen',
    symbol: '¥',
    type: 'fiat',
  },
  {
    name: 'AED',
    coinGeckoId: 'united-arab-emirates-dirham',
    symbol: 'AED',
    type: 'fiat',
    symbolPosition: 'after',
  },
  {
    name: 'SOL',
    coinGeckoId: 'solana',
    symbol: 'SOL',
    type: 'crypto',
    symbolPosition: 'after',
    networkId: 'solana',
  },
];

export const defaultCurrency = currencies.find((c) => c.name === 'USD')!;
